import React, {ReactElement, useContext} from 'react';
import {Typography, PhoneIcon, MailIcon} from '@customink/pigment-react';
import services from '../../api/remoteServices';
import {useSupportInfo} from '../../hooks/useSupportInfo';
import {MobileContext} from '../../containers/MobileProvider';
import './index.scss';

const Footer: React.FC = (): ReactElement => {
  const supportInfo = useSupportInfo('organizer-footer');
  const mobile = useContext(MobileContext);

  const SupportInfo = () => {
    return (
      <div className="organizer-footer-supportInfo">
        <Typography variant="captionSmall" gutterBottom>
          Need help? Talk to a real person 7 days a week.
        </Typography>

        <div className="email-phoneNumber-wrapper">
          <Typography variant="captionSmall" gutterBottom>
            <PhoneIcon fontSize="small" />
            <a href={`tel:${supportInfo?.phoneNumber}`} className="phoneNumber">
              {supportInfo?.phoneNumber}
            </a>
          </Typography>
          <Typography variant="captionSmall" gutterBottom className="email">
            <MailIcon fontSize="small" />
            <a href={`mailto:${supportInfo?.email}`}>Send us an email</a>
          </Typography>
        </div>

        <Typography variant="captionSmall" gutterBottom>
          {supportInfo?.hours}
        </Typography>
      </div>
    );
  };

  const CopyRightNotice = () => {
    return (
      <div className="organizer-footer-copyRight-notice">
        <Typography className="organizer-footer-text" variant="captionSmall">
          &copy; Custom Ink, LLC. All rights reserved.
        </Typography>
        <Typography className="organizer-footer-text" variant="captionSmall">
          <a
            href={`${services.homePage}/about/privacy`}
            target="_blank"
            rel="noreferrer">
            Privacy Policy
          </a>{' '}
          &nbsp;| &nbsp;{' '}
          <a
            href={`${services.homePage}/about/user_agreement`}
            target="_blank"
            rel="noreferrer">
            User Agreement
          </a>
        </Typography>
      </div>
    );
  };

  const footerClassNames = `organizer-footer${mobile ? ' mobile' : ''}`;

  return (
    <div className={footerClassNames}>
      <SupportInfo />
      <CopyRightNotice />
    </div>
  );
};

export default Footer;
